import React, { Component } from 'react';
import WowFind from 'components/wow/WowFind'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as wowActions from 'store/modules/wow';

// import cookie from 'react-cookies';

let timed = null;

class WowFindContainer extends Component {

  componentDidMount() {
    // const {WowActions} = this.props;

    goWclRequest(this);
    // console.log('COOKIE');
    // const {wclFilter0} = cookie.loadAll();
    // console.log(wclFilter0);
    // WowActions.setWclFilterOpt(JSON.parse(wclFilter0));
  }

  fnWclFilter = async (e) => {
    const {WowActions} = this.props;
    const {name, value, alt} = e.target;
    
    // cookie.save(name, JSON.stringify({'name': name, 'value':value,'alt':alt}), {path:'/'});
    WowActions.setWclFilterOpt({name, value, alt});
    
    clearTimeout(timed);
    timed = await setTimeout(goWclRequest, 800, this);
  }

  getReportData = ({report_code, fightID, name, cnt}) => {
    const {WowActions} = this.props;
    WowActions.setReportLoading(cnt);
    WowActions.getWclRequestReport(encodeURIComponent(report_code+"|"+fightID+"|"+name));
  }

  render() {
    const {fnWclFilter, getReportData} = this;
    const {wclFind, lang} = this.props;

    return (
      <WowFind fnWclFilter={fnWclFilter}
      wclFind={wclFind}
      getReportData={getReportData}
      lang={lang}
      />
    );
  }
}

export default connect(
  (state) => ({
    wclFind: state.wow.toJS().wclFind,
    lang: state.wow.toJS().lang
  }),
  (dispatch) => ({
    WowActions: bindActionCreators(wowActions, dispatch)
  })
)(WowFindContainer);

const goWclRequest = async (pThis) => {
  console.log('goWclRequest');
  const {WowActions, wclFind} = pThis.props;
  const {url, wclFilter0, wclFilter1, wclFilter2, wclFilter3, wclFilter4} = wclFind;
  const compUrl = url + wclFilter0.value + wclFilter1.value + wclFilter2.value + wclFilter3.value + wclFilter4.value;
  
  if(!(compUrl.indexOf('boss=-1') > -1)) { //올스타가아니고..
    if(compUrl.indexOf('boss=') > -1 && compUrl.indexOf('class=') > -1) { //보스,직업 골랐을때
      await WowActions.getWclRequestInfo(encodeURIComponent(compUrl));
      const {wclFind} = pThis.props;
      const {code, fightID} = wclFind.ranker[0].report;
      const {name: rankerName} = wclFind.ranker[0];
      
      WowActions.getWclRequestReport(encodeURIComponent(code+"|"+fightID+"|"+rankerName));

    }else{
      WowActions.setPendingInit();
    }
  }else{
    WowActions.setPendingInit();
  }
}